export const AllLayers = `
    query allLayers {
        allLayers (condition: {public: true}) {
            nodes {
                layerId
                layername
                geoType
                type
            }
    }
}
`;
